var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "quarterSegment",
    d: "M 50 50 L 50 0 A 50 50 0 0 1 100 50 Z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .spinner {\r\n      transform-origin: 50px 50px;\r\n      animation: spin 1s linear infinite;\r\n    }\r\n    \r\n    @keyframes spin {\r\n      100% { transform: rotate(360deg); }\r\n    }\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "spinner"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#quarterSegment",
    fill: "#4ca4dd",
    transform: "rotate(0 50 50)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#quarterSegment",
    fill: "#173264",
    transform: "rotate(90 50 50)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#quarterSegment",
    fill: "#e02d29",
    transform: "rotate(180 50 50)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#quarterSegment",
    fill: "#b62e12",
    transform: "rotate(270 50 50)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e3438e95643778eff16ec8dd1bef46c5.svg";
export { ForwardRef as ReactComponent };